module.exports = __webpack_public_path__ + "static/media/bm-zm25.cbb7ef03.png";